import React from 'react';
import type { VariantProps } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';

import { AccessibleLink } from '@components/main-components/link/AccessibleLink';

const LearnMoreLink = styled(AccessibleLink, {
  textDecoration: 'underline',
  whiteSpace: 'nowrap',

  variants: {
    textColor: {
      white: {
        color: '$white',
      },
      black: {
        color: '$black',
      },
    },
  },
  defaultVariants: {
    textColor: 'white',
  },
});
export const LearnMoreReferrals = ({
  withDot,
  ...props
}: VariantProps<typeof LearnMoreLink> & {
  withDot?: boolean;
}) => (
  <LearnMoreLink
    {...props}
    absoluteUri="https://help.sound.xyz/hc/en-us/articles/12713835355035"
    type="external"
  >
    Learn more{withDot ? '.' : ''}
  </LearnMoreLink>
);
